export enum EmployeeDocumentBehaviorTypeEnum {
  SIGNATURE = "SIGNATURE",
  UPLOAD = "UPLOAD",
}
